import React from 'react'
import { Card, Row, Col, Typography } from 'antd'

const { Title } = Typography

const DashboardReport = ({ data }) => {
  const dataS = [
    { title: 'Tổng tin đăng', value: data?.count_post || 0 },
    { title: 'Tổng yêu cầu', value: data?.count_request || 0 },
    { title: 'Tổng user', value: data?.count_user || 0 }
  ]

  return (
    <div style={{ background: '#F5F5F5', borderRadius: '8px', marginTop: 30 }}>
      <Title level={4}>Báo cáo thông tin theo hệ thống</Title>
      <Row gutter={16}>
        {dataS.map((item, index) => (
          <Col span={8} key={index}>
            <Card style={{ textAlign: 'center', borderRadius: '8px' }}>
              <Title level={5} style={{ color: '#888' }}>
                {item.title}
              </Title>
              <Title level={3} style={{ margin: 0 }}>
                {item.value}
              </Title>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  )
}

export default DashboardReport
